import useTable from '../../../hooks/useTable';
import { Table } from '../../Table';
import { TableComponentProps } from '../types';

const columnLables = {
  aifm_national_code: {
    name: 'AIFM national code',
    order: 16,
    disabled: true
  },
  aif_national_code: {
    name: 'AIF national code',
    order: 17,
    disabled: true
  },
  aif_name: {
    name: 'AIF name',
    order: 18
  },
  aif_eea_flag: {
    name: 'AIF EEA flag',
    order: 19
  },
  aif_reporting_code: {
    name: 'AIF reporting code',
    order: 20
  },
  aif_domicile: {
    name: 'Domicile of the AIF',
    order: 21
  },
  inception_date: {
    name: 'Inception date',
    order: 22
  },
  aif_no_reporting_flag: {
    name: 'AIF no reporting flag',
    order: 23
  }
};

export const FundIdentificationCodes2 = ({
  funds,
  currentDataKey,
  onChangeFund,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) => {
  const {
    rows: rows,
    columns: columns,
    onChange: onChange
  } = useTable({
    data: funds[currentDataKey]?.fund_data?.HEADER_SECTION,
    onChangeFund,
    schema: schema.HEADER_SECTION,
    isStaticTemplate,
    requiredFields: funds[currentDataKey]?.required_tables?.HEADER_SECTION?.field_names || [],
    isMultiFunds,
    funds,
    columnLables,
    tableName: 'HEADER_SECTION'
  });

  return (
    <Table
      id="reporttables-fund-identification-codes-2-table"
      handleChanges={onChange}
      stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 2 : null}
      stickyTopRows={isMultiFunds ? 1 : null}
      columns={columns}
      rows={rows}
    />
  );
};
